export default __webpack_public_path__ + "static/media/Laser_0001_Big-laser-start.83e9e502.png";